import React from 'react';

const ButtonPrime = () => {

  return (
    <>
        <button className='form-input-btn prime' type='submit'>
          Generuj Stopkę
        </button>
    </>
  );
};

export default ButtonPrime;